import React, { useState } from "react";
import "./Ajuda.css";

import thumbAgenteIA from "../assets/images/thumb-agente-ia.jpg";
import thumbFunilMensagens from "../assets/images/thumb-funil-mensagens.jpg";
import thumbWzp from "../assets/images/thumb-wzp.jpg";
import thumbTags from "../assets/images/thumb-tags.jpg";
import thumbSmartViews from "../assets/images/thumb-smartviews.jpg";

function Ajuda() {
  const [mensagemWhats, setMensagemWhats] = useState("");
  const [videoAberto, setVideoAberto] = useState(null);

  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    assunto: "",
    mensagem: "",
  });

  const tutoriais = [
    {
      titulo: "Agente de IA",
      descricao: "Aprenda como configurar e usar o agente de IA no atendimento.",
      thumb: thumbAgenteIA,
      videoId: "13R8Z3k8AVo",
    },
    {
      titulo: "Funil de Mensagens",
      descricao: "Veja como organizar conversas e acompanhar seus leads.",
      thumb: thumbFunilMensagens,
      videoId: "j0jWZqXomH4",
    },
    {
      titulo: "Ferramentas WhatsApp",
      descricao: "Conheça os principais recursos do WhatsApp dentro do CRM.",
      thumb: thumbWzp,
      videoId: "XIwsdn4q1xI",
    },
    {
      titulo: "Tags",
      descricao: "Aprenda a usar etiquetas para segmentar seus leads.",
      thumb: thumbTags,
      videoId: "mHEcOdmXBCg",
    },
    {
      titulo: "SmartViews",
      descricao: "Conheça como funcionam os SmartViews e controle seu faturamento.",
      thumb: thumbSmartViews,
      videoId: "o9yzn73H8yM",
    },
  ];

  function enviarWhatsAppSuporte() {
    const numero = "5512988039773";
    const texto = encodeURIComponent(
      mensagemWhats.trim() || "Olá, preciso de suporte no Nórea CRM."
    );

    window.open(`https://wa.me/${numero}?text=${texto}`, "_blank");
  }

  function handleChange(e) {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  function handleSubmit(e) {
    e.preventDefault();

    alert(
      "Sua solicitação foi registrada. Em breve nosso suporte entrará em contato."
    );

    setFormData({
      nome: "",
      email: "",
      assunto: "",
      mensagem: "",
    });
  }

  return (
    <div className="ajuda-page">
      <section className="ajuda-hero">
        <span className="ajuda-label">Suporte Nórea CRM</span>

        <h1>Como podemos te ajudar?</h1>

        <p>
          Escolha a melhor forma de falar com nossa equipe. Nosso atendimento
          acontece de segunda a sexta, das 09h às 18h.
        </p>
      </section>

      <section className="ajuda-grid">
        <div className="ajuda-card ajuda-card-whatsapp">
          <span className="ajuda-tag">Atendimento urgente</span>

          <h2>Fale pelo WhatsApp</h2>

          <p>
            Escreva sua mensagem abaixo e clique em enviar. O WhatsApp será
            aberto com a mensagem pronta para envio.
          </p>

          <textarea
            value={mensagemWhats}
            onChange={(e) => setMensagemWhats(e.target.value)}
            placeholder="Ex: Olá, estou com dificuldade para acessar meu CRM..."
            rows={6}
          />

          <button
            type="button"
            className="ajuda-btn ajuda-btn-whatsapp"
            onClick={enviarWhatsAppSuporte}
          >
            Enviar pelo WhatsApp
          </button>

          <span className="ajuda-horario">
            Atendimento de segunda a sexta, das 09h às 18h.
          </span>
        </div>

        <div className="ajuda-card">
          <span className="ajuda-tag">Não urgente</span>

          <h2>Abra uma solicitação</h2>

          <p>
            Para dúvidas, sugestões ou solicitações que não precisam de resposta
            imediata, envie uma mensagem pelo formulário.
          </p>

          <form className="ajuda-form" onSubmit={handleSubmit}>
            <div className="ajuda-form-group">
              <label>Nome</label>
              <input
                type="text"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                placeholder="Seu nome"
                required
              />
            </div>

            <div className="ajuda-form-group">
              <label>E-mail</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="seuemail@exemplo.com"
                required
              />
            </div>

            <div className="ajuda-form-group">
              <label>Assunto</label>
              <input
                type="text"
                name="assunto"
                value={formData.assunto}
                onChange={handleChange}
                placeholder="Sobre o que você precisa falar?"
                required
              />
            </div>

            <div className="ajuda-form-group">
              <label>Mensagem</label>
              <textarea
                name="mensagem"
                value={formData.mensagem}
                onChange={handleChange}
                placeholder="Descreva sua dúvida ou solicitação..."
                rows={5}
                required
              />
            </div>

            <button type="submit" className="ajuda-btn ajuda-btn-primary">
              Enviar solicitação
            </button>
          </form>
        </div>
      </section>

      <section className="ajuda-extra-grid">
        <div className="ajuda-card ajuda-email-card">
          <span className="ajuda-tag">E-mail</span>

          <h2>Suporte por e-mail</h2>

          <p>Você também pode falar com nossa equipe diretamente pelo e-mail:</p>

          <a href="mailto:contato@noreamkt.com.br" className="ajuda-email">
            contato@noreamkt.com.br
          </a>
        </div>
      </section>

      <section className="ajuda-tutoriais">
        <div className="ajuda-tutoriais-header">
          <span className="ajuda-tag">Tutoriais</span>

          <h2>Tutoriais rápidos</h2>

          <p>
            Assista aos vídeos abaixo para aprender a usar os principais
            recursos do Nórea CRM.
          </p>
        </div>

        <div className="ajuda-tutoriais-grid">
          {tutoriais.map((tutorial) => (
            <button
              key={tutorial.videoId}
              type="button"
              className="ajuda-tutorial-card"
              onClick={() => setVideoAberto(tutorial)}
            >
              <img src={tutorial.thumb} alt={tutorial.titulo} />

              <div>
                <h3>{tutorial.titulo}</h3>
                <p>{tutorial.descricao}</p>
              </div>
            </button>
          ))}
        </div>
      </section>

      {videoAberto && (
        <div
          className="ajuda-video-backdrop"
          onClick={() => setVideoAberto(null)}
        >
          <div
            className="ajuda-video-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="ajuda-video-fechar"
              onClick={() => setVideoAberto(null)}
            >
              ×
            </button>

            <h3>{videoAberto.titulo}</h3>

            <iframe
              src={`https://www.youtube.com/embed/${videoAberto.videoId}?autoplay=1`}
              title={videoAberto.titulo}
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Ajuda;